document.addEventListener('DOMContentLoaded', () => {
  if (!window.freeProductSettings) return;

  let thresholdUSD = Number(window.freeProductSettings.threshold); 
  let rate = Shopify.currency?.rate ? Number(Shopify.currency.rate) : 1;
  let threshold = thresholdUSD * rate;
  
  const freeProductVariantId = parseInt(window.freeProductSettings.variantId);
  let checking = false;

  const loader = document.createElement('div');
  loader.className = 'free-gift-loader';
  loader.innerHTML = `
    <div class="free-gift-loader__backdrop">
      <img src="https://cdn.shopify.com/s/files/1/0529/5013/9050/files/loading-22482_128_1.gif?v=1762950675" 
           alt="Loading..." 
           class="free-gift-loader__gif" />
      <p class="free-gift-loader__text">Adding your Free Product...</p>
    </div>
  `;
  document.body.appendChild(loader);

  function showLoader(message = 'Updating cart...') {
    loader.querySelector('.free-gift-loader__text').textContent = message;
    loader.style.display = 'flex';
  }

  function hideLoader() {
    loader.style.display = 'none';
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function addGift() {
    console.log('[free-Product] Adding Free Product...');
    showLoader('Adding your Free Product...');
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: freeProductVariantId, quantity: 1 })
    });
    await refreshCartUI();
    hideLoader();
  }
 
  async function removeGift(line) {
    console.log('[free-gift] Removing Free Product...');
    showLoader('Removing Free Product...');
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: 0 })
    });
    await refreshCartUI();
    hideLoader();
  }

  async function refreshCartUI() {
    console.log('[free-gift] Refreshing cart UI...');
    try {
      const isCartPage = window.location.pathname.includes('/cart');
      const sections = isCartPage
        ? ['main-cart-items', 'cart-icon-bubble']
        : ['cart-drawer', 'cart-icon-bubble'];

      const response = await fetch(`/?sections=${sections.join(',')}`);
      const sectionHTML = await response.json();

      for (const [sectionId, html] of Object.entries(sectionHTML)) {
        const container =
          document.getElementById(sectionId) ||
          document.querySelector(`[data-id="${sectionId}"]`) ||
          document.querySelector(`[id*="${sectionId}"]`);
        if (container) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html.trim();
          const innerCart = tempDiv.querySelector('.cart__items, .cart-drawer__contents');
          container.innerHTML = innerCart ? innerCart.outerHTML : html;
          console.log(`[free-gift] Updated section: ${sectionId}`);
        }
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && !window.location.pathname.includes('/cart')) {
        cartDrawer.renderContents({ sections: sectionHTML });
      }

      const cartData = await getCart();
    if (cartDrawer) {
      if (cartData.item_count === 0) {
        cartDrawer.classList.add('is-empty');
        console.log('[free-gift] Cart is empty — added .is-empty class');
      } else {
        cartDrawer.classList.remove('is-empty');
      }
    }

    if (isCartPage) {
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl) {
        if (cartData.item_count === 0) {
          cartItemsEl.classList.add('is-empty');
          console.log('[free-gift] Cart page empty — added .is-empty to <cart-items>');
        } else {
          cartItemsEl.classList.remove('is-empty');
        }
      }
    }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.error('[free-gift] refreshCartUI error', err);
      hideLoader();
    }
  }

  async function checkGift() {
    if (checking) return;
    checking = true;
    try {
      const cart = await getCart();
      const total = (cart.total_price || 0) / 100;
      const giftIndex = cart.items.findIndex(i => i.variant_id === freeProductVariantId);
      const hasGift = giftIndex !== -1;

      console.log(`[free-Product] Cart total: ${total} | Has Product: ${hasGift}`);

      if (cart.items.length === 1 && hasGift) {
        console.log('[free-Product] Only gift item remains. Removing Product and showing empty cart.');
        await removeGift(giftIndex + 1);
        return; 
      }

      if (total >= threshold && !hasGift) {
        console.log('[free-gift] Threshold met. Adding Product.');
        await addGift();
      } else if (total < threshold && hasGift) {
        console.log('[free-gift] Threshold not met. Removing Product.');
        await removeGift(giftIndex + 1);
      }
    } catch (err) {
      console.error('[free-gift] checkGift error', err);
      hideLoader();
    } finally {
      checking = false;
    }
  }

  checkGift();

  document.addEventListener('cart:updated', checkGift);

  const observer = new MutationObserver(() => checkGift());
  observer.observe(document.body, { childList: true, subtree: true });

  document.body.addEventListener('click', e => {
    if (
      e.target.closest('[data-cart-remove]') ||
      e.target.closest('[name="update"]') ||
      e.target.closest('.cart__quantity-button') ||
      e.target.closest('.ajax-cart-button')
    ) {
      setTimeout(checkGift, 500);
    }
  });
});
